// Tarife tablosunun sütunları. Anahtarlar tarife kaydındaki (zenginleştirilmiş)
// alan adlarıdır; `id`: tariffs.columns.<id>. Sıra eski tabloyla aynı, sona
// yalnızca görüntülenen Durum (aktif/pasif) eklendi.

export const TARIFF_COLUMNS = {
  customerName: { id: 'customer', type: 'text', width: 240 },
  projectName: { id: 'project', type: 'text', width: 180 },
  type: { id: 'type', type: 'text', width: 155 },
  value: { id: 'value', type: 'text', width: 160 },
  price: { id: 'price', type: 'text', width: 140 },
  amount: { id: 'amount', type: 'text', width: 220 },
  currency: { id: 'currency', type: 'select', width: 130, options: ['TRY', 'USD', 'EUR', 'GBP'] },
  date: { id: 'date', type: 'date', width: 170 },
  isSubcontractor: { id: 'subcontractor', type: 'select', width: 175, options: ['Evet', 'Hayır'] },
  info: { id: 'info', type: 'text', width: 220 },
  // Görüntüleme: FTE düzenlemesinde kaldırılan değerler pasif (active: false)
  active: { id: 'status', width: 120 },
};

export const COLUMN_KEYS = Object.keys(TARIFF_COLUMNS);
export const DEFAULT_VISIBLE_COLUMNS = Object.fromEntries(COLUMN_KEYS.map((key) => [key, true]));
export const MIN_COLUMN_WIDTH = 96;
export const PINNED_COLUMNS = ['customerName'];

// Seçim filtreleri hemen, metin ve tarih filtreleri en az 3 karakterde uygulanır
// (useTariffs'taki süzme ile aynı kural)
const INSTANT_FILTERS = new Set(['currency', 'isSubcontractor']);

export const getFilterState = (key, value) => {
  if (value === undefined || value === null || String(value) === '') return 'off';
  if (INSTANT_FILTERS.has(key)) return 'applied';
  return String(value).trim().length >= 3 ? 'applied' : 'pending';
};
